import React from "react";
import "./socialfooter.css";

const SocialFooter = () => {
  return (
    <div className="social-footer">

      {/* TikTok */}
      <a
        href="https://www.tiktok.com/@ghost.crew.hr"
        target="_blank"
        rel="noreferrer"
        className="social-icon tiktok"
      >
        <i className="fab fa-tiktok"></i>
      </a>

      {/* Instagram */}
      <a
        href="https://www.instagram.com/ghost.crew.hr/"
        target="_blank"
        rel="noreferrer"
        className="social-icon instagram"
      >
        <i className="fab fa-instagram"></i>
      </a>

      {/* Facebook */}
      <a
        href="https://www.facebook.com/groups/973468294183282"
        target="_blank"
        rel="noreferrer"
        className="social-icon facebook"
      >
        <i className="fab fa-facebook-f"></i>
      </a>

    </div>
  );
};

export default SocialFooter;